import { Component, OnInit } from '@angular/core';

import { tanquesModuleName } from "../shared/data.service";
import { UtilService } from "../../../shared/services/util.service";
import {abastecimentosRoute, abastecimentosModuleName} from "../../shared/data.service";
import { AbastecimentoService } from "../../shared/abastecimento.service";
import { Tanque } from "../shared/tanque.model";
import { TanqueApiService } from "../shared/tanque-api.service";
import { TanqueService } from "../shared/tanque.service";
import { TanqueNavigationService } from "../shared/tanque-navigation.service";
import {configuracaoModuleName} from "../../../shared/services/data.service";

@Component({
    template: require('./tanque-list.component.html'),
    styles: [require('./tanque-list.component.css')]
})
export class TanqueListComponent implements OnInit {
    list: Tanque[] = [];
    loading: boolean = true;
    showDisabled: boolean = false;
    tanquesModuleName: any = tanquesModuleName;
    abastecimentosRoute: string = abastecimentosRoute;
    module: any = abastecimentosModuleName;
    configuracaoModule: any = configuracaoModuleName;

    constructor(
        private _tanquesApiService: TanqueApiService,
        private _tanqueService: TanqueService,
        private _tanqueNavigationService: TanqueNavigationService,
        private _utilService: UtilService,
        private _abastecimentoService: AbastecimentoService
    ) { }

    ngOnInit() {
        this.getAll();
    }

    clickNew() {
        this._tanqueService.clearSessionStorage();
        this._tanqueNavigationService.goToNew();
    }

    clickGoToSettings() {
        this._abastecimentoService.goToSetting();
    }

    clickEdit(item: Tanque) {
        this._tanqueService.clearSessionStorage();
        this._tanqueNavigationService.goToEdit(item.id);
    }

    clickDelete(item: Tanque) {
        var onDelete = (function() {
            this.onDelete(item);
        }.bind(this));

        this._utilService.swalMessageDelete(onDelete);
    }

    private getAll() {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                this.list = Response;
            }
            this.loading = false;
        }.bind(this));

        this._tanquesApiService.onGetAll(onDone);
    }

    private onDelete(item: any) {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                var x: number, lenX: number;
                for (x = 0, lenX = this.list.length; x < lenX; x++) {
                    if (this.list[x].id === item.id) {
                        this.list[x].ativo = false;
                        break;
                    }
                }
                this._utilService.swalMessageDeleteSuccess();
            } else {
                this._utilService.swalMessageDeleteError();
            }
        }.bind(this));

        this._tanquesApiService.onDelete(item.id, onDone);
    }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/abastecimentos/tanques/tanque-list/tanque-list.component.ts
 **/